var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"mr-3",attrs:{"placeholder":"Sélectionner une boites de réception","size":_vm.size,"value":_vm.value,"disabled":_vm.disabled || (_vm.receptionBoxes && _vm.receptionBoxes.length == 0)},on:{"input":function($event){return _vm.$emit('input', $event)}}},[_vm._t("default"),_vm._l((_vm.receptionBoxes),function(ref){
var id = ref.id;
var name = ref.name;
return _c('el-option',{key:id,attrs:{"value":id,"label":name}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }